import React, { useEffect, useState } from 'react';

const FinancialGoalsCard = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimate(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const goals = [
    { icon: '🏠', label: 'Home Purchase', timeline: '5-7 Years' },
    { icon: '🎓', label: 'Child Education', timeline: '10-15 Years' },
    { icon: '🏖️', label: 'Retirement', timeline: '20-25 Years' }
  ];

  return (
    <div className="bg-white rounded-xl shadow-md p-4 sm:p-6 h-full flex flex-col">
      {/* Header */}
      <div className="mb-4 sm:mb-6">
        <h3 className={`text-lg sm:text-xl font-semibold text-[#113262] mb-2 transition-all duration-800 ${
          animate ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
        }`}>
          Set financial goals that truly matter
        </h3>
        <p className={`text-sm text-[#545454] transition-all duration-800 delay-300 ${
          animate ? 'opacity-100' : 'opacity-0'
        }`}>
          Prioritize investments based on your life goals like buying a house, child education, or retirement.
        </p>
      </div>

      {/* Goals Grid */}
      <div className="grid grid-cols-3 gap-2 sm:gap-4 mb-4 sm:mb-6 flex-1">
        {goals.map((goal, index) => (
          <div
            key={index}
            className={`bg-gradient-to-br from-[#E8EEF6] to-[#A2B8D8] p-3 sm:p-4 rounded-lg text-center border-2 border-transparent hover:border-[#1C52A0] transition-all duration-500 transform hover:-translate-y-1 ${
              animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
            style={{ 
              animationDelay: `${200 + index * 200}ms`,
              transitionDelay: `${600 + index * 200}ms`
            }}
          >
            <div className={`w-8 h-8 sm:w-12 sm:h-12 bg-gradient-to-br from-[#11326240] to-[#1C52A040] rounded-lg flex items-center justify-center text-[#113262] text-lg sm:text-2xl font-bold mx-auto mb-2 sm:mb-3 transition-all duration-700 ${
              animate ? 'scale-100 rotate-0' : 'scale-0 -rotate-180'
            }`}
            style={{ transitionDelay: `${800 + index * 200}ms` }}>
              {goal.icon}
            </div>
            <h4 className="text-xs sm:text-sm font-semibold text-[#113262] mb-1">
              {goal.label}
            </h4>
            <p className="text-xs text-[#545454] font-medium">
              {goal.timeline}
            </p>
          </div>
        ))}
      </div>

      {/* Progress Section */}
      <div className={`bg-[#F5F5F5] p-3 sm:p-4 rounded-lg text-center transition-all duration-800 delay-1000 ${
        animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}>
        <div className="text-xs sm:text-sm text-[#545454] mb-3">
          Goal Achievement Progress
        </div>
        
        <div className="h-2 bg-[#E6E6E6] rounded-full overflow-hidden mb-3">
          <div 
            className={`h-full bg-gradient-to-r from-[#113262] to-[#1C52A0] rounded-full transition-all duration-2000 ease-in-out ${
              animate ? 'w-3/5' : 'w-0'
            }`}
            style={{ transitionDelay: '1200ms' }}
          />
        </div>
        
        <button onClick={() => window.location.href = "https://club.maxiomwealth.com/goals/finplan/create"} className={`bg-gradient-to-r from-[#113262] to-[#1C52A0] text-white px-4 sm:px-6 py-2 rounded-lg text-xs sm:text-sm font-semibold hover:scale-105 hover:shadow-lg transition-all duration-300 ${
          animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
        }`}
        style={{ transitionDelay: '1400ms' }}>
          Set Your Goals
        </button>
      </div>
    </div>
  );
};

export default FinancialGoalsCard;